module.exports = __webpack_public_path__ + "fonts/montserrat-bolditalic-webfont.7565bfa.woff";